import { Directive, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import {
  ParcellaStragiudizialeAdapter
} from '../../../components/fascicolo/parcelle-stragiudiziali-edit/parcella-stragiudiziale-adapter';
import { CompetenzaParcella } from '../../../models/competenza-parcella';


import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';

import { SezioneLegaliResponse } from '../../../models/dto/sezione-legali-response';
import { LegaleIncaricato } from '../../../models/legale-incaricato';
import { ParcellaStragiudiziale } from '../../../models/parcella-stragiudiziale';

import { QuadroCompensiParcella } from '../../../models/quadro-compensi-parcella';
import { ScaglioneParcella } from '../../../models/scaglione-parcella';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneLegali } from '../../../models/sezioni/sezione-legali';
import { Categoria } from '../../../models/tipologiche/categoria';
import { Cpa } from '../../../models/tipologiche/cpa';
import { FaseCompensoParcella } from '../../../models/tipologiche/fase-compenso-parcella';
import { Iva } from '../../../models/tipologiche/iva';

import { ValoriRiferimentoParcella } from '../../../models/valori-riferimento-parcella';
import { NumericOperationManager } from '../../../utils/numeric-operation-manager';
import { BaseForm } from '../../base-Form';
import { ParcellaStragiudizialeQuadroPercentualeForm } from './parcella-stragiudiziale-quadro-percentuale-form';
import { ParcellaStragiudizialeQuadroTabellareForm } from './parcella-stragiudiziale-quadro-tabellare-form';

declare var removeEmptyObject: any;
declare var $: any;

@Directive()
export abstract class AvvidoParcellaForm extends BaseForm implements OnInit {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  parcellaStragiudiziale: ParcellaStragiudiziale;
  // form
  request: ParcellaStragiudiziale;
  riepilogo: ParcellaStragiudiziale = null;
  parcellaStragiudizialeForm: any;
  msgNoBeneficiari: string;

  // options
  tipiLegale: Categoria[] = [];
  legaliAll: LegaleIncaricato[] = [];
  legaliOptions: LegaleIncaricato[] = [];
  competenzeOptions: CompetenzaParcella[] = [];
  scaglioniOptions: ScaglioneParcella[] = [];
  valoriRiferimentoParcellaOptions: ValoriRiferimentoParcella[] = [];
  ivaOptions: Iva[] = [];
  cpaOptions: Cpa[] = [];

  // parametri abstract
  abstract getParcellaStragiudiziale(): ParcellaStragiudiziale;
  abstract getRequest(request: ParcellaStragiudiziale);
  abstract getUrlReadSezioneLegali(): string;
  abstract getUrlReadSezioneEconomica(): string;
  abstract getUrlGetScaglioni(): string;
  abstract getTipoFascicolo(): any;
  abstract getTipoPratica(): any;
  abstract getIdFascicolo(): string;

  // importi calcolati
  totaleQuadroCompensi: any = 0;

  // variabili
  quadroCompensi: QuadroCompensiParcella[] = [];
  idCompetenza: string;
  importoPetitum: any;
  isDisabledScaglioni: boolean = false;
  isDisabledValore: boolean = true;
  isCheckedTabellare: boolean;
  percentualeVal: string;
  importoBase: any;
  importoPattuito: any = 0;

  // isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD;

  // toggle html
  visibleToggleAssocia: boolean = false;
  visibleToggleForm: boolean = false;
  visibleToggleRiepilogo: boolean = false;

  @ViewChild('quadroCompensiTabellareForm') quadroCompensiTabellareForm: ParcellaStragiudizialeQuadroTabellareForm;
  @ViewChild('quadroCompensiPercentualeForm') quadroCompensiPercentualeForm: ParcellaStragiudizialeQuadroPercentualeForm;
  @ViewChild('searchItem') searchItemRef!: ElementRef;

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

  ngOnInit(){
    // this.isPrd = PropertiesSettings.ID_TENANTS_PRD;
  }

  initRequest() {
    this.request = new ParcellaStragiudizialeAdapter(this.getParcellaStragiudiziale()).parcellaStragiudiziale;
    this.request.flagParcella = false;
    this.importoBase = this.request.importoBase;
    if(this.request.importoBase){
      this.importoPattuito = this.request.importoBase;
    }
    if (!this.request.spesa.percSpesaGenerale) {
      this.request.spesa.percSpesaGenerale = 0;
    }

    if (this.quadroCompensiTabellareForm) {
      this.quadroCompensiTabellareForm.resetQuadroCompensi();
    }

    if (this.quadroCompensiPercentualeForm) {
      this.quadroCompensiPercentualeForm.resetQuadroCompensi();
    }
    this.initViewToggle();
    this.populateSelect();
    if (!this.inserimento) {
      this.importoPattuito = this.request.importoBase; // this.request.legale.compensoPattuito;
    } else {
      this.importoPattuito=0;
    }
  }

  initViewToggle() {
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
    this.visibleToggleRiepilogo = false;

    if (this.inserimento) {
      this.visibleToggleAssocia = true;
      this.visibleToggleForm = false;
    }
  }

  createForm() {
    this.initRequest();
    // this.importoPattuito=0;
    this.request = new ParcellaStragiudizialeAdapter(this.getParcellaStragiudiziale()).parcellaStragiudiziale;
    this.request.flagParcella = false;
    this.parcellaStragiudizialeForm = this.campiForm.group({
      id: [this.request.id],
      legale: [this.request.legale],
      dataParcella: [this.request.dataParcella, Validators.required],
      numeroParcella: [this.request.numeroParcella],
      compensoPattuito: [(this.request.legale) ? this.request.legale.compensoPattuito : 0],
      importoBase: [(this.request.importoBase) ? this.request.importoBase : 0],
      percentualeImportoBase: [this.request.percentualeImportoBase],
      flagIva: [this.request.flagIva],
      iva: [this.request.iva],
      flagCpa: [this.request.flagCpa],
      cpa: [this.request.cpa],
      flagRitenutaAcconto: [this.request.flagRitenutaAcconto],
      importoParcella: [this.request.importoParcella],
      spesa: [this.request.spesa],
      spesaEsente: [this.request.spesa && this.request.spesa.spesaEsente ? this.request.spesa.spesaEsente : 0],
      spesaTrasferta: [this.request.spesa && this.request.spesa.spesaTrasferta ? this.request.spesa.spesaTrasferta : 0],
      altraSpesaImponibile: [this.request.spesa && this.request.spesa.altraSpesaImponibile ? this.request.spesa.altraSpesaImponibile : 0],
      contributoUnificato: [this.request.contributoUnificato],
      flagSpesaGenerale: [this.request.spesa ? this.request.spesa.flagSpesaGenerale : false],
      percSpesaGenerale: [this.request.spesa && this.request.spesa.percSpesaGenerale ? this.request.spesa.percSpesaGenerale : 0],
      note: [this.request.note],
      documenti: [this.request.documenti],
      maggiorazione: [this.request.maggiorazione]

    });
  }

  formValid(): boolean {
    let result: boolean = false;
    if (this.percentualeVal && this.percentualeVal.toString().trim().length !== 0 && (!this.request.spesa || (this.request.spesa && this.request.spesa.percSpesaGenerale>=0)) && this.checkIvaCpa()) {
      result = true;
    }
    if (!this.request.spesa || (this.request.spesa && this.request.spesa.percSpesaGenerale>=0) && this.checkIvaCpa()) {
      result = true;
    }
    return result;
  }

  public setTextEmpty() {
    this.searchItemRef.nativeElement.value = '';
  }


  checkIvaCpa(): boolean {
    let result: boolean = false;
    if (this.request.flagCpa) {
      if (this.request.cpa && this.request.cpa.id !== '-1') {
        result = true;
      }
    } else {
      result = true;
    }
    if (result) {
      if (this.request.flagIva) {
        if (this.request.iva && this.request.iva.id !== '-1') {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = true;
      }
    }
    return result;
  }


  populateSelect() {
    if (this.tipiLegale.length === 0) {
      this.helpers.getCategorieLegaleIncaricato().subscribe(response => this.tipiLegale = response);
    }
    if (this.ivaOptions.length === 0) {
      this.helpers.getIva().subscribe(response => this.ivaOptions = response);
    }
    if (this.cpaOptions.length === 0) {
      this.helpers.getCpa().subscribe(response => this.cpaOptions = response);
    }
  }





  setCompensoPattuito(event){
    this.request.legale.compensoPattuito=Number.parseFloat(event);
  }

  setModePercentuale() {
    if (this.isCheckedTabellare) {
      this.quadroCompensiPercentualeForm.resetQuadroCompensi();
      this.isDisabledScaglioni = true;
      this.isCheckedTabellare = false;
      if (!this.request.percentualeImportoBase) {
        this.percentualeVal = '5';
      } else {
        this.percentualeVal = this.request.percentualeImportoBase;
      }
      this.quadroCompensiPercentualeForm.valorePercentuale = this.percentualeVal;
      this.request.importoPetitumRiferimento = this.request.importoPetitumRiferimento;
      this.inizializzaQuadro();
      this.request.scaglione = null;
    }
  }

  getValoriRiferimento(response) {
    this.valoriRiferimentoParcellaOptions = response;
    this.inizializzaQuadro();
  }

  onChangePercentuale(_value: string) {
    this.percentualeVal = _value;
    this.quadroCompensiPercentualeForm.valorePercentuale = this.percentualeVal;
    this.inizializzaQuadro();
  }


  onChangePetitum(_value: string) {
    this.request.importoPetitumRiferimento = _value;
    this.quadroCompensiPercentualeForm.valorePetitum = this.request.importoPetitumRiferimento;
    this.inizializzaQuadro();
  }

  validate(event: any, _value: string) {
    this.quadroCompensiPercentualeForm.validate(event, _value);
  }

  inizializzaQuadro() {
    if (this.quadroCompensiTabellareForm && this.quadroCompensiPercentualeForm) {
      if (this.isCheckedTabellare) {
        this.quadroCompensiTabellareForm.valoriRiferimentoParcella = this.valoriRiferimentoParcellaOptions;
        this.quadroCompensiTabellareForm.fasiCompensi = this.request.fasiCompensi;
        this.quadroCompensiTabellareForm.createQuadroCompensi();
      } else {
        this.quadroCompensiPercentualeForm.valoriRiferimentoParcella = this.valoriRiferimentoParcellaOptions;
        this.quadroCompensiPercentualeForm.fasiCompensi = this.request.fasiCompensi;
        this.quadroCompensiPercentualeForm.createQuadroCompensi();
      }

    }
  }

  save() {
    this.getRequest(this.riepilogo);
  }

  readSezioneLegali(idSezioneLegali: string) {
    if (idSezioneLegali) {
      this.operationService.readSezione(this.getUrlReadSezioneLegali(), idSezioneLegali)
        .subscribe(response =>
          this.readSezioneLegaliResponse((<SezioneLegaliResponse>response).sezione));
    }
  }

  readSezioneLegaliResponse(sezioneLegali: SezioneLegali) {
    this.legaliAll = sezioneLegali.legaliIncaricati;
    this.legaliAll = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.revocato === false && legaleIncaricato.categoriaLegaleIncaricato.descrizione==='LEGALE ESTERNO' });
    this.msgNoBeneficiari = 'Non esistono beneficiari da associare';
    if (this.getParcellaStragiudiziale() && !this.inserimento) {
      this.legaliOptions = this.legaliAll.filter(legaleIncaricato => { return legaleIncaricato.categoriaLegaleIncaricato.id === this.getParcellaStragiudiziale().legale.categoriaLegaleIncaricato.id; });
    }
  }

  readSezioneEconomica(idSezioneDatiEconomici: string) {
    if (idSezioneDatiEconomici) {
      this.operationService.readSezione(this.getUrlReadSezioneEconomica(), idSezioneDatiEconomici)
        .subscribe(response => this.readSezioneEconomicaResponse((<SezioneEconomicaResponse>response).sezione));
    }
  }

  readSezioneEconomicaResponse(sezioneEconomica: SezioneEconomica) {
    if (!this.parcellaStragiudiziale) {
      if(sezioneEconomica.petitum) this.importoPetitum = sezioneEconomica.petitum.importoPetitum;
    } else {
      this.importoPetitum = this.parcellaStragiudiziale.importoPetitumRiferimento;
    }
    this.request.importoPetitumRiferimento = this.importoPetitum;
  }

  populateLegali(event: any) {
    if (event.target.value && this.legaliAll.length > 0) {
      this.legaliOptions = this.legaliAll.filter(legale => { return legale.categoriaLegaleIncaricato.id === event.target.value; });
    }
  }

  calcolaCompenso(obj: any) {
    // this.getLegale(obj);
    // this.request.legale.compensoPattuito = this.importoPattuito;
    let newFasiCompenso: FaseCompensoParcella[] = [];
    if(this.quadroCompensi){
      for (let f of this.quadroCompensi) {
        let fase: FaseCompensoParcella = new FaseCompensoParcella();
        if (f.checkedFase) {
          fase.fase = f.fase;
          fase.id = f.idFase;
          if (typeof f.compenso === 'string') {
            fase.compenso = this.stringToNumber(f.compenso);
          } else {
            fase.compenso = f.compenso;
          }
          newFasiCompenso.push(fase);
        }
      }
    }
    // if (this.request.spesa && this.request.spesa.percSpesaGenerale && Number(this.request.spesa.percSpesaGenerale) > 0) {
    //   this.request.spesa.flagSpesaGenerale = true;
    // } else {
    //   this.request.spesa.flagSpesaGenerale = false;
    // }
    this.request.spesa.flagSpesaGenerale=true;
    this.request.fasiCompensi = newFasiCompenso;
    if (!this.isCheckedTabellare) {
      this.request.fasiCompensi = null;
      this.request.percentualeImportoBase = this.percentualeVal;
      //this.request.importoBase = '' + newFasiCompenso[0].compenso;
    }
    //this.request.importoPetitumRiferimento = this.request.importoPetitumRiferimento;
    this.calcolaTotaleDocumento(this.request);
  }

  calcolaTotaleDocumento(parcellaStragiudiziale: ParcellaStragiudiziale) {
    if(parcellaStragiudiziale.legale.compensoPattuito)
      parcellaStragiudiziale.importoBase = parcellaStragiudiziale.legale.compensoPattuito;
    this.helpers.buildProspettoParcella(parcellaStragiudiziale).subscribe(response => this.getTotaleDocumento(response));
  }

  getTotaleDocumento(parcellaStragiudiziale: ParcellaStragiudiziale) {
    this.goToRiepilogo(parcellaStragiudiziale);
  }

  goToRiepilogo(parcellaStragiudiziale: ParcellaStragiudiziale) {
    this.riepilogo = parcellaStragiudiziale;
    this.visibleToggleRiepilogo = true;
    this.visibleToggleForm = false;
  }

  goToAssociaLegale() {
    this.createForm();
    this.visibleToggleAssocia = true;
    this.visibleToggleForm = false;
  }

  goToForm() {
    this.visibleToggleRiepilogo = false;
    this.visibleToggleForm = true;
  }

  associaLegale(legaleIncaricato: LegaleIncaricato) {
    this.getLegale(legaleIncaricato);
    this.visibleToggleAssocia = false;
    this.visibleToggleForm = true;
  }

  getLegale(obj: any) {
    if (obj.id) {
      this.request.legale = this.legaliAll.filter(legale => { return legale.id === obj.id; })[0];
      this.importoPattuito = this.request.legale.compensoPattuito;
    }
  }

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  stringToNumber(value: string): number {
    value = value.replace(',', '.');
    return Number(value);
  }

  refresh(quadroCompensiParcella: QuadroCompensiParcella[]) {
    this.quadroCompensi = quadroCompensiParcella;
    this.totaleQuadroCompensi = 0;
    for (let q of quadroCompensiParcella) {
      if (q.checkedFase) {
        this.totaleQuadroCompensi = this.getSum(this.totaleQuadroCompensi, q.compenso);
      }
    }
    this.request.importoBase = this.totaleQuadroCompensi;
  }

  private getBeneficiarioLabel(legaleIncaricato: LegaleIncaricato): string {
    let result = '';
    if (legaleIncaricato && legaleIncaricato.legale && legaleIncaricato.legale.tipoPersona) {
      if (legaleIncaricato.legale.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
        result = legaleIncaricato.legale.cognome + ' ' + legaleIncaricato.legale.nome;
      }
      if (legaleIncaricato.legale.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
        result = legaleIncaricato.legale.ragioneSociale;
      }
    }
    return result;
  }

  changeFlagIva(event) {
    if (event) {
      this.request.iva = this.ivaOptions.find(el => el.valore === 22);
    } else {
      this.request.iva = null;
    }
  }

  changeFlagCpa(event) {
    if (event) {
      this.request.cpa = this.cpaOptions.find(el => el.valore === 4);
    } else {
      this.request.cpa = null;
    }
  }

}
